import React, { useRef, useState } from 'react';
import { Marker as WebMarker } from '@react-google-maps/api';

import styles from './styles';

const Marker = ({
  coordinate,
  coordinateChanged,
  draggable = true,
  icon,
  onPress,
}) => {
  const marker = useRef(null);
  const [position, setPostiion] = useState({ ...coordinate });
  const webMarkerConditionalProps = { onClick: onPress };
  if (icon) {
    webMarkerConditionalProps.icon =
      typeof icon === 'string'
        ? {
            scaledSize: styles.markerStyle,
            url: icon,
          }
        : icon;
  }

  const onPositionChanged = () => {
    if (draggable && marker.current != null) {
      const lat = marker.current.marker.getPosition().lat();
      const lng = marker.current.marker.getPosition().lng();
      setPostiion({ lat: lat, lng: lng });
    }
  };

  return (
    <WebMarker
      ref={marker}
      position={coordinate}
      draggable={draggable}
      onDragEnd={() => {
        if (draggable) {
          coordinateChanged(
            { latitude: position.lat, longitude: position.lng },
            { isGesture: true },
          );
        }
      }}
      onPositionChanged={onPositionChanged}
      {...webMarkerConditionalProps}
    />
  );
};

export default Marker;
